import { baseApi } from '@/store/api/baseApi';
import type { AppSettings, UpdateSettingsPayload } from '@/types/settings';

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<AppSettings, void>({
      query: () => '/settings',
      providesTags: [{ type: 'Settings', id: 'APP' }],
    }),
    updateSettings: builder.mutation<AppSettings, UpdateSettingsPayload>({
      query: (body) => ({ url: '/settings/update', method: 'POST', body }),
      invalidatesTags: [{ type: 'Settings', id: 'APP' }],
    }),
    testSmtp: builder.mutation<{ message: string; to: string }, { to?: string }>({
      query: (body) => ({ url: '/settings/test-smtp', method: 'POST', body }),
    }),
  }),
});

export const { useGetSettingsQuery, useUpdateSettingsMutation, useTestSmtpMutation } = settingsApi;
